export default __webpack_public_path__ + "3b5aef497202bbc27a8144a5ca67dc8c.png";